import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { auth } from "../firebase/auth";

export const AuthGuard = () => {
  const [user, setUser] = useState<null | object>(undefined as any);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setChecking(false);
    });
    return unsub;
  }, []);

  if (checking) return <div style={{ color: "#fff", textAlign: "center", marginTop: 100 }}>Cargando...</div>;

  if (!user) return <Navigate to="/admin/login" replace />;

  return <Outlet />;
};
